<template>
  <el-dialog center :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">

      <el-form-item label="原密码" prop="oldPassword">
        <el-input v-model="form.oldPassword" type="password">
        </el-input>
      </el-form-item>


      <el-form-item label="新密码" prop="password">
        <el-input v-model="form.password" type="password">
        </el-input>
      </el-form-item>

      <el-form-item label="确认密码" prop="confirmPassword">
        <el-input v-model="form.confirmPassword" type="password">
        </el-input>
      </el-form-item>

    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancelDialog('form')">取 消</el-button>
      <el-button type="primary" @click="updatePassword('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import fetch from "../api/fetch";

export default {
  name: 'change-password',
  components: {

  },
  data() {
    let checkPasswordStrength = (rule, value, callback) => {
      var modes = 0
      if (/\d/.test(value)) {//如果用户输入的密码 包含了数字
        modes++
      }
      if (/[a-z]/.test(value)) {//如果用户输入的密码 包含了小写的a到z
        modes++
      }
      if (/[A-Z]/.test(value)) {//如果用户输入的密码 包含了大写的A到Z
        modes++
      }
      if (/\W/.test(value)) {//如果是非数字 字母 下划线
        modes++
      }
      if (modes < 3) {
        callback(new Error('密码强度太弱!'))
      } else {
        callback()
      }
    }
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    }
    return {
      form: {
        oldPassword: undefined,
        password: undefined,
        confirmPassword: undefined
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 7,
            max: 15,
            message: '长度在 7 到 15 个字符!',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          },
          {
            min: 7,
            max: 15,
            message: '长度在 7 到 15 个字符!',
            trigger: 'blur'
          }, {
            validator: checkPasswordStrength, trigger: 'blur'
          }
        ],
        confirmPassword: [
          {
            required: true,
            message: '确认密码不能为空',
            trigger: 'blur'
          },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      dialogStatus: 'modifyPwd',
      textMap: {
        modifyPwd: '修改密码'
      }
    }
  },
  computed: {
  },
  methods: {
    showChangePassword() {
      this.dialogFormVisible = true
    },
    cancelDialog(formName) {
      this.restModifyPwdForm()
      this.dialogFormVisible = false
    },
    updatePassword(formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        if (valid) {
          fetch({ url: '/client/user/change-password', method: 'post', data: this.form }).then(response => {
            // this.http.post('/client/user/change-password', this.form).then(response => {
            if (response.code === 'SUCCESS') {
              this.$notify({
                title: "成功",
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              this.restModifyPwdForm()
              this.dialogFormVisible = false
              this.$emit('handleChangePwdSuccess')
            } else if (response.code === 'ERROR') {
              this.$notify({
                title: "失败",
                message: response.message,
                type: 'error',
                duration: 2000
              })
            } else {
              this.$notify({
                title: '失败',
                message: '修改失败',
                type: 'error',
                duration: 2000
              })

            }
          }
          )
        }
      })
    },
    restModifyPwdForm() {
      this.form = {
        oldPassword: undefined,
        password: undefined,
        confirmPassword: undefined
      };
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/comm/components/ChangePassword.vue